module.exports = __webpack_public_path__ + "69b0577ca9cd1000c235eef5fcd302ad.png";